module.exports = __webpack_public_path__ + "img/icons-fill-customers.8018464d.svg";